import { a as IntlFormatError } from './error-CcshV7Gp-MfHpjqUW.js';
import { g as getNamedFormat, f as filterProps } from './utils-C5QdPtcV-A5kGtUmj.js';

var NUMBER_FORMAT_OPTIONS = ['style', 'currency', 'unit', 'unitDisplay', 'useGrouping', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits',
// ES2020 NumberFormat
'compactDisplay', 'currencyDisplay', 'currencySign', 'notation', 'signDisplay', 'unit', 'unitDisplay', 'numberingSystem',
// ES2023 NumberFormat
'trailingZeroDisplay', 'roundingPriority', 'roundingIncrement', 'roundingMode'];
function getFormatter(_a, getNumberFormat, options) {
  var locale = _a.locale,
    formats = _a.formats,
    onError = _a.onError;
  if (options === void 0) {
    options = {};
  }
  var format = options.format;
  var defaults = format && getNamedFormat(formats, 'number', format, onError) || {};
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults);
  return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
  if (options === void 0) {
    options = {};
  }
  try {
    return getFormatter(config, getNumberFormat, options).format(value);
  } catch (e) {
    config.onError(new IntlFormatError('Error formatting number.', config.locale, e));
  }
  return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
  if (options === void 0) {
    options = {};
  }
  try {
    return getFormatter(config, getNumberFormat, options).formatToParts(value);
  } catch (e) {
    config.onError(new IntlFormatError('Error formatting number.', config.locale, e));
  }
  return [];
}

export { formatNumber as a, formatNumberToParts as f };
//# sourceMappingURL=number-KrLmL8vq-BVtk9XJ6.js.map
